var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('section',[_c('Modules',{attrs:{"modules":_vm.page.modules || _vm.page.attributes.modules}}),_vm._v(" "),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }